import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import TimelineHeader from './common/TimelineHeader';

import AbstractTimelineEvent from 'components/layout/embeddedTimeline/AbstractTimelineEvent';

class TimelineTextMessageSent extends AbstractTimelineEvent {
  render() {
    const { intl } = this.props;
    const messages = intl.messages;

    return (
      <div>
        <TimelineHeader
          creatorId={this.getDynParam('creatorId')}
          creatorAvatar={this.getDynParam('creatorAvatar')}
          creatorName={this.getDynParam('creatorName')}
          title={messages.sent_text_message}
        />

        <div class="card-block">
          <h5 class="m-t-0 m-l-0 m-r-0 m-b-5">{this.getDynParam('subject')}</h5>
          <p>{this.getDynParam('content')}</p>
        </div>
      </div>
    );
  }
}
TimelineTextMessageSent.propTypes = {
  event: PropTypes.object,
};

export default injectIntl(TimelineTextMessageSent);
